import React from 'react'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import moment from 'moment'
import Modal from 'react-modal'

import { modal } from '../../core/utilities/modal'
import { generatePDF } from '../../helpers/General/GeneratePDF';
import { lease } from '../../core/controllers/Lease';
import { user } from '../../core/controllers/user';
import { modalStyles } from '../../core/controllers/ModalStyles';
import DotProgress from '../../core/utilities/DotProgress';

export default class LeasePaymentHistory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            transactionHistory: null,
            showModal: false,
            showInvoiceModal: false,
            newDate: null,
            selectedTransaction: null,
            chargeAmount: 0,
            type: null,
            description: null,
        };

        this.paymentMade = false
        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        if(this.props.leaseID) {
            lease.getTransactionHistoryWithLeaseId(function(response){
                self.setState({
                    transactionHistory: self.formatTransactions(response.data),
                });
            }, this.props.leaseID);
        }
    }
    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        // format money
        var money = parseFloat(value);
        if(isNaN(money) || money === 0) {
            money = 0;
        } else {
            money = money / 100;
            money.toLocaleString("en-US", {style:"currency", currency:"USD"});
        }

        return money;
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatMoney(cell, row) {
        return '$' + this.formatAmount(cell);
    }

    formatDate(cell, row) {
        return moment(cell).format('D MMM YYYY');
    }

    changeDate(transaction) {
        this.setState({showModal: true, selectedTransaction: transaction});
    }

    showInvoiceModal() {
        this.setState({showInvoiceModal: true, selectedTransaction: null});
    }

    handleNewDueDate(e) {
        this.setState({
            newDate: e.target.value
        });
    }

    handleAmountChange(e) {
        this.setState({
            chargeAmount: e.target.value
        });
    }

    handleTypeChange(e){
        this.setState({
                type: e.target.value
        });
    }

    handleDescriptionChange(e){
        this.setState({
                description: e.target.value
        });
    }

    formatDateAndClick(cell, row) {
        if (row.status == 'NONE' && user.userInfo.user_type_alias != 'tenant') {
            if (cell == null) {
                return (
                    <span onClick={this.changeDate.bind(this, row)}>
                        Not Set&nbsp;
                        <i class="pe-7s-pen download-invoice"></i>
                    </span>
                )
            } else {
                return (
                    <span onClick={this.changeDate.bind(this, row)}>
                        {moment(cell).format('D MMM YYYY')}&nbsp;
                        <i class="pe-7s-pen download-invoice"></i>
                    </span>
                )
            }
        } else {
            if (cell == null) {
                return (
                    <span>
                        Not Set&nbsp;
                    </span>
                )
            } else {
                return moment(cell).format('D MMM YYYY');
            }
        }
    }

    formatStatus(cell, row) {
        var status = <DotProgress dotPos={2} date={row.due_at}/>
        if (cell == 'PAID') {
            status = <DotProgress dotPos={3} date={row.due_at}/>
        } else if (cell == 'VOID') {
            status = '<span class="important-small-gray">Cancelled</span>';
        } else if (cell == 'EXPIRED') {
            status = '<span class="important-small-red">Expired</span>';
        } else if (cell == 'FAILED') {
            status = '<span class="important-small-red">Failed</span>';
        } else if (cell == 'REFUNDED') {
            status = '<span class="important-small-blue">Refund</span>';
        } else if (cell == 'NONE') {
            status = <DotProgress dotPos={1} date={row.due_at}/>
        }

        return status;
    }

    downloadInvoice(invoice) {
        generatePDF.generateTenantInvoicePDF(invoice, function(response){
            modal.showInfo("PDF should begin downloading shortly.", "success", "top", "center");
        });
    }

    markAsPaid(invoice) {
        var self = this;
        modal.showDangerModalWithOK("Mark Paid", "Are you sure you want to mark this invoice as paid?", "Continue");
        jQuery(".move-on").on('click',function() {
            lease.markInvoicePaid(invoice, function(){
                modal.showInfo("Invoice marked as paid.", "success", "top", "center");
                if(self.props.leaseID) {
                    lease.getTransactionHistoryWithLeaseId(function(response){
                        self.setState({
                            transactionHistory: self.formatTransactions(response.data)
                        });
                    }, self.props.leaseID);
                }
            });
        });
    }

    voidTransaction(invoice) {
        var self = this;
        modal.showDangerModalWithOK("Cancel Payment", "Are you sure you want to cancel this payment?", "Cancel");
        jQuery(".move-on").on('click',function() {
            lease.voidTransaction(invoice, function(){
                modal.showInfo("Payment was cancelled.", "success", "top", "center");
                if(self.props.leaseID) {
                    lease.getTransactionHistoryWithLeaseId(function(response){
                        self.setState({
                            transactionHistory: self.formatTransactions(response.data)
                        });
                    }, self.props.leaseID);
                }
            });
        });
    }

    deleteTransaction(invoice) {
        var self = this;
        modal.showDangerModalWithOK("Cancel Payment", "Are you sure you want to cancel this payment?", "Cancel");
        jQuery(".move-on").on('click',function() {
            lease.deleteTransaction(invoice, function(){
                modal.showInfo("Payment was cancelled.", "success", "top", "center");
                if(self.props.leaseID) {
                    lease.getTransactionHistoryWithLeaseId(function(response){
                        self.setState({
                            transactionHistory: self.formatTransactions(response.data)
                        });
                    }, self.props.leaseID);
                }
            });
        });
    }

    actions(cell, row) {
        return (
            <span>
            { row.status != 'PAID' && (
            <span onClick={this.markAsPaid.bind(this, row)}>
                <i class="pe-7s-check download-invoice"></i>
            </span>
                )}
            <span onClick={this.downloadInvoice.bind(this, row)}>
                <i class="pe-7s-download download-invoice"></i>
            </span>
            { row.status == 'IN_PROCESS' && row.is_credit_card == false && (
            <span onClick={this.voidTransaction.bind(this, row)}>
                <i class="pe-7s-close-circle download-invoice"></i>
            </span>
            )}
            { row.status == 'NONE' && user.userInfo.user_type_alias != 'tenant' && (
            <span onClick={this.deleteTransaction.bind(this, row)}>
                <i class="pe-7s-close-circle download-invoice"></i>
            </span>
            )}
            </span>
        )
    }

    handleCloseModal() {
        this.setState({ showModal: false, showInvoiceModal: false });
    }

    updatePaymentDate(invoice) {
        var self        = this;
        const newDate   = this.state.newDate;

        if(newDate == null) {
            modal.showInfo("Select a new payment due date.", "warning", "top", "center");
            return false;
        }

        modal.showDangerModalWithOK("Update Payment Due Date", "Are you sure you want to update the payment due date?", "Yes");
        jQuery(".move-on").on('click',function() {
            lease.updatePaymentDate(invoice, newDate, function(){
                modal.showInfo("Payment due date was updated.", "success", "top", "center");
                if(self.props.leaseID) {
                    lease.getTransactionHistoryWithLeaseId(function(response){
                        self.setState({
                            transactionHistory: self.formatTransactions(response.data),
                            showModal: false,
                            showInvoiceModal: false,
                            newDate: null,
                            selectedTransaction: null
                        });
                    }, self.props.leaseID);
                }
            });
        });
    }

    validateData() {
        const chargeAmount = this.state.chargeAmount;
        const newDate   = this.state.newDate;
        const type      = this.state.type;

        if(newDate == null) {
            modal.showInfo("Select a rent payment due date.", "warning", "top", "center");
            return false;
        } else if (chargeAmount == null || chargeAmount <= 0) {
            modal.showInfo("Enter the amount you want to charge for this invoice.", "warning", "top", "center");
            return false;
        } else if(isNaN(chargeAmount)) {
            modal.showInfo("The amount entered is formatted incorrectly.", "warning", "top", "center");
            return false;
        } else if(type == null){
            modal.showInfo("Select a transaction type.", "warning", "top", "center");
        }

        return true;
    }

    formatTransactions(transactionHistory) {
        var formattedTransactions = [];
        if(transactionHistory != null) {
            transactionHistory.forEach(transaction => {
                const history = transaction.history;
                const details = transaction.transaction;
                if (details != null) {
                    var transactionType = "";
                    if (history.is_security_deposit == 1) {
                        transactionType = "Security Deposit"
                    } else if (history.is_pet_deposit == 1) {
                        transactionType = "Pet Deposit"
                    } else if (history.is_rent_payment == 1) {
                        transactionType = "Rent Payment"
                    } else if (history.transaction_type == 1) {
                        transactionType = "Maintenence"
                    }  else if (history.transaction_type == 2) {
                        transactionType = "Other"
                    }  else if (history.transaction_type == 3) {
                        transactionType = "Fee"
                    } else if (history.transaction_type == 4) {
                        transactionType = "Owner Payout"
                    } else if (history.transaction_type == 5) {
                        transactionType = "Vendor Invoice"
                    } else if (history.transaction_type == 6) {
                        transactionType = "Security Deposit"
                    } else if (history.transaction_type == 7) {
                        transactionType = "Pet Deposit"
                    } else if (history.transaction_type == 8) {
                        transactionType = "Tenant Payout"
                    } else if (history.transaction_type == 9) {
                        transactionType = "Utility"
                    } else if (details.rent == 0 && details.water == 0 && details.disposal == 0 && details.sewage == 0) {
                        if (details.processing_fee == 0) {
                            transactionType = "Other Payment"
                        } else {
                            if (details.charge == details.processing_fee) {
                                transactionType = "Admin/Service Fees"
                            } else {
                                transactionType = "Other Payment + Admin/Service Fees"
                            }
                        }
                    } else {
                        if (details.rent != 0) {
                            if (transactionType == "") {
                                transactionType += "Rent"
                            } else {
                                transactionType += " + Rent"
                            }
                        }
                        if (details.water != 0) {
                            if (transactionType == "") {
                                transactionType += "Water"
                            } else {
                                transactionType += " + Water"
                            }
                        }
                        if (details.disposal != 0) {
                            if (transactionType == "") {
                                transactionType += "Disposal"
                            } else {
                                transactionType += " + Disposal"
                            }
                        }
                        if (details.sewage != 0) {
                            if (transactionType == "") {
                                transactionType += "Sewage"
                            } else {
                                transactionType += " + Sewage"
                            }
                        }
                        if (details.late_rent != 0) {
                            if (transactionType == "") {
                                transactionType += "Late Rent"
                            } else {
                                transactionType += " + Late Rent"
                            }
                        }
                        if (details.processing_fee != 0) {
                            if (transactionType == "") {
                                transactionType += "Admin/Service Fees"
                            } else {
                                transactionType += " + Admin/Service Fees"
                            }
                        }
                    }
                }

                if (transaction.transaction == null) {
                    return;
                }

                const row = {
                    transaction_type: transactionType,
                    tenant_payment_history_id: transaction.history.tenant_payment_history_id,
                    tenant_id: transaction.history.tenant_id,
                    contract_id: transaction.history.contract_id,
                    is_rent_payment: transaction.history.is_rent_payment,
                    is_security_deposit: transaction.history.is_security_deposit,
                    description: transaction.history.description,
                    is_pet_deposit: transaction.history.is_pet_deposit,
                    tenant_transaction_id: transaction.transaction.tenant_transaction_id,
                    due_at: transaction.history.due_at,
                    created_at: transaction.history.created_at,
                    charge: transaction.transaction.charge,
                    rent: transaction.transaction.rent,
                    water: transaction.transaction.water,
                    sewage: transaction.transaction.sewage,
                    processing_fee: transaction.transaction.processing_fee,
                    status: transaction.status,
                    is_credit_card: transaction.is_credit_card
                }

                formattedTransactions.push(row);
            });
        }

        return formattedTransactions;
    }

    generateRentInvoice() {
        if(!this.validateData()){
            return;
        }

        var self           = this;
        const chargeAmount = this.state.chargeAmount;
        const dueDate      = this.state.newDate;
        const id           = this.props.leaseID;
        const type         = this.state.type;
        const description  = this.state.description;
        modal.showDangerModalWithOK("Are you sure?", "You are about to generate a new invoice.  Tenant(s) will be notified of the payment.", "Yes, Create!");
		jQuery(".move-on").on('click',function() {
            lease.createRentInvoice(id, chargeAmount, dueDate, type, description, function(response) {
                modal.resetBackDrop();
                modal.showSuccess('Invoice Created!', 'This invoice was successfully created and tenants have been notified!');
                self.handleCloseModal();
                if(self.props.leaseID) {
                    lease.getTransactionHistoryWithLeaseId(function(response){
                        self.setState({
                            transactionHistory: self.formatTransactions(response.data)
                        });
                    }, self.props.leaseID);
                }
            });
        });
    }

    render(){
        var self                    = this;
        const newDate               = this.state.newDate;
        const showModal             = this.state.showModal;
        const showInvoiceModal      = this.state.showInvoiceModal;
        const selectedTransaction   = this.state.selectedTransaction;
        const chargeAmount          = this.state.chargeAmount;
        const type                  = this.state.type;
        const description           = this.state.description;
        const formattedTransactions = this.state.transactionHistory;
        return (
            <div class="content table-full-width">
                <Modal
                    isOpen={showModal}
                    onRequestClose={this.handleCloseModal.bind(this)}
                    style={modalStyles.getModalStyles()}
                    ariaHideApp={false}>
                    <div>
                        <div class="row">
                            <div class="modal-exit-icon pull-right" onClick={this.handleCloseModal.bind(this)}></div>
                        </div>
                        <div class="row">
                            <div class="modal-header">Change Payment Due Date</div>
                        </div>
                        <form>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-6 col-md-offset-3">
                                            <div class="form-group">
                                                <label for="assignee">What is the new due date?</label>
                                                <input type="date" class="form-control" onChange={this.handleNewDueDate.bind(this)} value={newDate} placeholder="Select a new payment due date." />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-3">
                                    <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.updatePaymentDate.bind(this, selectedTransaction)}>
                                        Change Date
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal>
                <Modal
                    isOpen={showInvoiceModal}
                    onRequestClose={this.handleCloseModal.bind(this)}
                    style={modalStyles.getModalStyles()}
                    ariaHideApp={false}>
                    <div>
                        <div class="row">
                            <div class="modal-exit-icon pull-right" onClick={this.handleCloseModal.bind(this)}></div>
                        </div>
                        <div class="row">
                            <div class="modal-header">Create Invoice</div>
                        </div>
                        <form>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-6 col-md-offset-3">
                                            <div class="form-group">
                                                <label for="assignee">What date is this due?</label>
                                                <input type="date" class="form-control" onChange={this.handleNewDueDate.bind(this)} value={newDate} placeholder="Select a new payment due date." />
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-md-offset-3">
                                            <div class="form-group">
                                                <label>Description</label>
                                                <input type="text" class="form-control" value={description} placeholder="Description" onChange={this.handleDescriptionChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-md-offset-3">
                                            <div class="form-group">
                                                <label>Transaction Type</label>
                                                <select class="form-control" value={type} onChange={this.handleTypeChange.bind(this)}>
                                                    <option value='0'>Rent Payment</option>
                                                    <option value='6'>Security Deposit</option>
                                                    <option value='7'>Pet Deposit</option>
                                                    <option value='9'>Utility</option>
                                                    <option value='3'>Fee</option>
                                                    <option value='2'>Other</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-md-offset-3">
                                        <label for="assignee">Amount</label>
                                            <div class="form-group has-feedback">
                                                <input type="text" value={chargeAmount} onChange={this.handleAmountChange.bind(this)} class="form-control input-group-dollar-addon" placeholder="How much is rent?"/>
                                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-3">
                                    <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.generateRentInvoice.bind(this)}>
                                        Create Invoice
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal>
                <div class="row">
                    <div class="col-md-12">
                        <div class="content"></div>
                        {formattedTransactions != null ? (
                            window.innerWidth < 992 ? (
                            <BootstrapTable data={formattedTransactions} version='4' striped search pagination>
                                <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='transaction_type' dataSort={ true }>Title</TableHeaderColumn>
                                <TableHeaderColumn dataField='description' dataSort={ true }>Description</TableHeaderColumn>
                                <TableHeaderColumn dataField='charge' width="120" dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Amount</TableHeaderColumn>
                                <TableHeaderColumn dataField='status' width="120" dataFormat={this.formatStatus.bind(this)} dataSort={ true }>Status</TableHeaderColumn>
                            </BootstrapTable>
                            ) : (
                            <BootstrapTable data={formattedTransactions} version='4' striped search pagination>
                                <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='transaction_type' dataSort={ true }>Title</TableHeaderColumn>
                                <TableHeaderColumn dataField='description' dataSort={ true }>Description</TableHeaderColumn>
                                <TableHeaderColumn dataField='charge' width="120" dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Amount</TableHeaderColumn>
                                <TableHeaderColumn dataField='status' width="120" dataFormat={this.formatStatus.bind(this)} dataSort={ true }>Status</TableHeaderColumn>
                                <TableHeaderColumn dataField='due_at' width="150" dataFormat={this.formatDateAndClick.bind(this)} dataSort={ true }>Due Date</TableHeaderColumn>
                                <TableHeaderColumn dataField='created_at' width="150" dataFormat={this.formatDate} dataSort={ true }>Submitted</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={this.actions.bind(this)} width="100"></TableHeaderColumn>
                            </BootstrapTable>
                            )
                        ) : (
                            <p>No payment history found.</p>
                        )}
                        <div class="content" style={{float: "right"}}>
                            <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.showInvoiceModal.bind(this)}>
                                Generate Invoice
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Billing/LeasePaymentHistory.jsx